import { gql } from "apollo-boost";

export const GET_DAMAGED_PRODUCT = gql`
  query DamagedProduct($where: DamagedProductWhereInputOne) {
  damagedProduct(where: $where) {
    id
    stock {
      id
    }
    shop {
      name
    }
    damageType
    damageReason
    damageDate
    damagedAmount
    name
    images
    createdAt
    updatedAt
    isDeleted
  }
}
`;

export const GET_DAMAGED_PRODUCTS = gql`
query DamagedProducts {
  damagedProducts {
    id
    stock {
      id
    }
    shop {
      name
    }
    damageType
    damageReason
    damageDate
    damagedAmount
    name
    images
    createdAt
    updatedAt
    isDeleted
  }
}`